import React from 'react';
import comimg from '../exp_logo/exp-common.png';

export default function Experience() {
  return (
    <>
    <div className="subheadings exps">
        <h1>Experience</h1>
        {/* <div className="search-exp">
            <input type="text" className="form-control searchsubheadings searchexpsinput" placeholder="Search..."/>
        </div> */}
        <div className="experience-tilldate">
          <div className="card experience-card exp-b">
            <div className="card-body exp-card-body">
              <div className="common-img">
                <img src={comimg} alt='common-img' className='exp-common-image'/>
              </div>
              <div className="card-desc exp-card-desc">
                  <h5 className="card-title exp-card-title">Software Engineer</h5>
                  <div className="location-and-company">
                    <div className="exp-inner-icons company-icon">
                      <i className="fa-regular fa-building"></i>
                      <div className="tooltip company-tt">Fermion Infotech</div>
                    </div>
                    <div className="exp-inner-icons location-icon">
                      <i className="fa-solid fa-earth-asia"></i>
                      <div className="tooltip location-tt">Navi Mumbai, India</div>
                    </div>
                  </div>
                  <div className="card-dur exp-dur">
                      Apr 2025 - present 
                  </div>
                  <p className="card-text exp-card-role">Building and maintaining tax, GST, admin, and web applications. Skilled in delivering compliance-driven updates, backend logic, and dashboard enhancements across PHP, Node.js, and JavaScript-based systems, with a strong focus on reliability and data-driven workflows.</p>
              </div>
            </div>
          </div>
          <div className="card-pointer">
            <i className="fa-regular fa-circle-dot"></i>
          </div>
          <div className="centerline"></div>
        </div>

        <div className="experience-tilldate second">
          <div className="card experience-card exp-a">
            <div className="card-body exp-card-body">
              <div className="common-img">
                <img src={comimg} alt='common-img' className='exp-common-image'/>
              </div>
              <div className="card-desc exp-card-desc">
                  <h5 className="card-title exp-card-title">Jr Software Engineer</h5>
                  <div className="location-and-company">
                    <div className="exp-inner-icons company-icon">
                      <i className="fa-regular fa-building"></i>
                      <div className="tooltip company-tt">Fermion Infotech</div>
                    </div>
                    <div className="exp-inner-icons location-icon">
                      <i className="fa-solid fa-earth-asia"></i>
                      <div className="tooltip location-tt">Navi Mumbai, India</div>
                    </div>
                  </div>
                  <div className="card-dur exp-dur">
                      Apr 2023 - Mar 2025 
                  </div>
                  <p className="card-text exp-card-role">Responsible for crafting and maintaining robust server-side PHP code within the Magento framework for an eCommerce website.</p>
              </div>
            </div>
          </div>
          <div className="card-pointer">
            <i className="fa-regular fa-circle-dot"></i>
          </div>
          <div className="centerline"></div>
        </div>
    </div>
    </>
  )
}
